export default __webpack_public_path__ + "static/layout-do-light-32d6064a240dba66fa845ca5207e948a.png";